export const TAGS = {
	ME: 'Me',
	USERS: 'Users',
	DEMO_REQUESTS: 'DemoRequests',
	COMPANY_BUSINESS_INFO: 'CompanyBusinessInfo',
	CLIENT_TAX_PLANS: 'ClientTaxPlans',
	TAX_PLAN: 'TaxPlan',
	TAX_PLAN_FEES: 'TaxPlanFees',
	TAX_PLAN_FEE: 'TaxPlanFee',
	TAX_PLAN_STRATEGIES: 'TaxPlanStrategies',
	TAX_PLAN_SIMULATOR: 'TaxPlanSimulator',
	ORGANIZATION: 'Organization',
	CHAT_HISTORIES_TABLE: 'ChatHistoriesTable',
	NOTES: 'Notes',
	NOTE: 'Note',
	TAX_STRATEGY_CALCULATION: 'TaxStrategyCalculation',
	CLIENT_PERSONAL_INFO: 'ClientPersonalInfo',
	CLIENT_COUNT: 'ClientCount',
	TAX_STRATEGY: 'Tax Strategy',
	OPPORTUNITIES: 'Opportunities',
	RISKS: 'Risks',
	LINKS: 'Links',
	FILES: 'Files',
	ACTIVITY_LOGS: 'ActivityLogs',
	THREADS: 'Threads',
	CHAT_BY_THREAD_ID: 'ChatByThreadId',
	CHAT_STREAM: 'ChatStream',
	COMPANIES: 'Companies',
	CLIENTS: 'Clients',
	CLIENT_DRAFT: 'ClientDraft',
	QUESTIONNAIRE: 'Questionnaire',
	TAX_RETURN_ANALYSIS: 'TaxReturnAnalysis',
	CLIENT_BASIC_INFO: 'ClientBasicInfo',
	CLIENT_INFORMATION: 'ClientInformation',
	TAX_PLAN_DETAILS: 'TaxPlanDetails',
	STRATEGIES_ENTITY: 'StrategiesEntity',
	TAX_OVERVIEW: 'TaxOverview',
	TAX_PLAN_AI_REPORT: 'TaxPlanAiReport',
	CUSTOM_PRICES: 'CustomPrices',
	MY_PLAN: 'MyPlan',
	LOSS_LIMITS: 'LossLimits'
}
